import React, { useRef, useEffect } from "react";
import { FaFileInvoiceDollar } from "react-icons/fa";
import html2pdf from "html2pdf.js";

export default function InvoiceModal({ booking, onClose }) {
  const invoiceRef = useRef();

  useEffect(() => {
    function handleKeyDown(e) {
      if (e.key === "Escape") onClose && onClose();
    }
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [onClose]);

  if (!booking) return null;

  const fare = Number(booking.finalFare);
  const commission = Math.round(fare * 0.12 * 100) / 100;
  const gst = Math.round(commission * 0.18 * 100) / 100;
  const netPayout = Math.round((fare - commission - gst) * 100) / 100;

  function handleDownloadPDF() {
    const element = invoiceRef.current;
    const bookingId = booking.bookingId || "invoice";
    const btn = document.querySelector('.print-btn');
    if (btn) btn.style.display = 'none';
    html2pdf()
      .set({
        margin: 0.5,
        filename: `invoice-${bookingId}.pdf`,
        image: { type: 'jpeg', quality: 0.98 },
        html2canvas: { scale: 2 },
        jsPDF: { unit: 'in', format: 'a4', orientation: 'portrait' }
      })
      .from(element)
      .save()
      .then(() => {
        if (btn) btn.style.display = '';
      });
  }

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(44, 62, 80, 0.18)",
        zIndex: 1200,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 0,
        overflow: "auto",
      }}
      onClick={e => {
        if (e.target === e.currentTarget) onClose && onClose();
      }}
    >
      <div
        ref={invoiceRef}
        style={{
          maxWidth: 400,
          width: "96vw",
          minWidth: 0,
          background: "#fff",
          borderRadius: 10,
          boxShadow: "0 4px 24px rgba(44,62,80,0.13)",
          padding: "18px 4vw 18px 4vw",
          fontSize: 15,
          color: "#232b35",
          border: "1px solid #e0e0e0",
          position: "relative",
          margin: "24px auto",
          overflowY: "auto",
          maxHeight: "92vh",
          transition: "max-width 0.2s",
        }}
        onClick={e => e.stopPropagation()}
      >
        <button
          onClick={onClose}
          style={{
            position: "absolute",
            top: 8,
            right: 8,
            background: "#1976d2",
            color: "#fff",
            border: "none",
            borderRadius: "50%",
            width: 28,
            height: 28,
            fontWeight: 700,
            fontSize: 16,
            cursor: "pointer",
            zIndex: 2,
            lineHeight: "28px",
            padding: 0,
            boxShadow: "0 2px 8px rgba(44,62,80,0.07)",
          }}
          aria-label="Close"
        >
          ×
        </button>
        {/* Header */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            borderBottom: "2px solid #e0e0e0",
            paddingBottom: 10,
            marginBottom: 12,
            flexWrap: "wrap",
            gap: 8,
            background: "#fff",
            borderRadius: "8px 8px 0 0",
            color: "#232b35",
          }}
        >
          <div>
            <div
              style={{
                fontWeight: 900,
                fontSize: 18,
                color: "#232b35",
                letterSpacing: 0.5,
              }}
            >
              Bhada24
            </div>
            <div style={{ color: "#232b35", fontSize: 11, marginTop: 2 }}>
              <span>
                bhada24x7@gmail.com
              </span>{" "}
              | <span>+91-9140251119</span>
            </div>
          </div>
          <div
            style={{
              background: "#fff",
              color: "#232b35",
              fontWeight: 700,
              fontSize: 13,
              borderRadius: 6,
              padding: "5px 12px",
              border: "1px solid #e0e0e0",
              marginLeft: "auto",
            }}
          >
            FARE DETAILS
          </div>
        </div>
        {/* Vehicle and Settlement Details */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginBottom: 12,
            gap: 12,
            flexWrap: "wrap",
          }}
        >
          <div style={{ flex: 1, minWidth: 120 }}>
            <div
              style={{
                fontWeight: 700,
                fontSize: 13,
                marginBottom: 4,
                color: "#232b35",
                display: "flex",
                alignItems: "center",
                gap: 4,
              }}
            >
              <FaFileInvoiceDollar style={{ marginRight: 2 }} /> Vehicle Details
            </div>
            <div>
              Vehicle No: <b>{booking.cabNumber || "DL01AB1234"}</b>
            </div>
            <div>
              Model: <b>{booking.cabName || "Toyota Innova"}</b>
            </div>
          </div>
          <div style={{ flex: 1, minWidth: 120 }}>
            <div
              style={{
                fontWeight: 700,
                fontSize: 13,
                marginBottom: 4,
                color: "#232b35",
                display: "flex",
                alignItems: "center",
                gap: 4,
              }}
            >
              <FaFileInvoiceDollar style={{ marginRight: 2 }} /> Reference
            </div>
            <div>
              BID: <b>{booking.bookingId}</b>
            </div>
            <div>
              Date: <b>{booking.pickupDateTime?.slice(0, 10)}</b>
            </div>
          </div>
        </div>
        {/* Settlement Summary */}
        <div style={{ marginBottom: 16 }}>
          <div
            style={{
              fontWeight: 700,
              fontSize: 14,
              marginBottom: 6,
              color: "#232b35",
              display: "flex",
              alignItems: "center",
              gap: 4,
            }}
          >
            <FaFileInvoiceDollar style={{ marginRight: 2 }} /> Fare Summary
          </div>
          <table
            style={{
              width: "100%",
              fontSize: 13,
              marginBottom: 8,
              borderCollapse: "collapse",
              background: "#fff",
            }}
          >
            <thead>
              <tr style={{ background: "#f7f7f7" }}>
                <th
                  style={{
                    textAlign: "left",
                    padding: "6px 6px",
                    borderBottom: "1px solid #e0e0e0",
                    color: "#232b35",
                  }}
                >
                  Particulars
                </th>
                <th
                  style={{
                    textAlign: "right",
                    padding: "6px 6px",
                    borderBottom: "1px solid #e0e0e0",
                    color: "#232b35",
                  }}
                >
                  Amount (₹)
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td
                  style={{
                    padding: "6px 6px",
                    borderBottom: "1px solid #e0e0e0",
                  }}
                >
                  Ride Fare
                </td>
                <td
                  style={{
                    textAlign: "right",
                    padding: "6px 6px",
                    borderBottom: "1px solid #e0e0e0",
                  }}
                >
                  {fare.toFixed(2)}
                </td>
              </tr>
              <tr>
                <td
                  style={{
                    padding: "6px 6px",
                    borderBottom: "1px solid #e0e0e0",
                  }}
                >
                  Less: Commission (12%)
                </td>
                <td
                  style={{
                    textAlign: "right",
                    padding: "6px 6px",
                    borderBottom: "1px solid #e0e0e0",
                  }}
                >
                  {commission.toFixed(2)}
                </td>
              </tr>
              <tr>
                <td
                  style={{
                    padding: "6px 6px",
                    borderBottom: "1px solid #e0e0e0",
                  }}
                >
                  Less: GST on Commission (18%)
                </td>
                <td
                  style={{
                    textAlign: "right",
                    padding: "6px 6px",
                    borderBottom: "1px solid #e0e0e0",
                  }}
                >
                  {gst.toFixed(2)}
                </td>
              </tr>
              <tr style={{ fontWeight: 700, background: "#f7f7f7" }}>
                <td
                  style={{
                    padding: "8px 6px",
                    borderTop: "2px solid #e0e0e0",
                    color: "#232b35",
                  }}
                >
                  Net Payout
                </td>
                <td
                  style={{
                    textAlign: "right",
                    padding: "8px 6px",
                    borderTop: "2px solid #e0e0e0",
                    color: "#232b35",
                  }}
                >
                  {netPayout.toFixed(2)}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        {/* Important Notes */}
        <div
          style={{
            marginBottom: 12,
            background: "#f7f7f7",
            border: "1px solid #e0e0e0",
            borderRadius: 6,
            padding: "10px 12px",
          }}
        >
          <div
            style={{
              fontWeight: 700,
              fontSize: 12,
              marginBottom: 4,
              color: "#232b35",
              display: "flex",
              alignItems: "center",
              gap: 4,
            }}
          >
            <FaFileInvoiceDollar style={{ marginRight: 2 }} /> Important Notes
          </div>
          <div style={{ fontSize: 12, color: "#232b35" }}>
            Bhada24 deducts commission + GST before payout.
            <br />
            Drivers have no GST liability.
          </div>
        </div>
        {/* Download Button */}
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            gap: 8,
            marginTop: 12,
          }}
        >
          <button
            onClick={handleDownloadPDF}
            className="print-btn"
            style={{
              background: "#1976d2",
              color: "#fff",
              border: "none",
              borderRadius: 6,
              fontWeight: 700,
              fontSize: 15,
              padding: "10px 24px",
              cursor: "pointer",
              boxShadow: "0 2px 8px rgba(44,62,80,0.07)",
            }}
            title={`Download as invoice-${booking.bookingId}.pdf`}
          >
            Download PDF
          </button>
        </div>
        <style>
          {`
            @media (max-width: 600px) {
              .print-btn {
                width: 100%;
                margin-top: 10px;
              }
              table {
                font-size: 12px !important;
              }
              div[style*="maxWidth: 400px"] {
                padding: 8px 2vw !important;
              }
            }
            @media print {
              .print-btn {
                display: none !important;
              }
            }
            table th, table td {
              font-family: inherit;
            }
          `}
        </style>
      </div>
    </div>
  );
}